<template>
  <div>
    <DashFilters @filter-changed="onFilterChanged" />
    <div v-if="chartData && chartData.length" style="width: 900px; height: 700px">
      <DxPieChart
        v-if="chartData && chartData.length"
        ref="pieChart"
        :data-source="chartData"
        type="doughnut"
        palette="Soft Pastel"
        :inner-radius="0.6"
        resolve-label-overlapping="shift"
        :title="$t('reporting.management_board.crop_rotation_overview')"
      >
        <DxExport :enabled="true" />
        <DxSeries argument-field="culture" value-field="area">
          <DxLabel :visible="true" position="outside" format="fixedPoint" :precision="2" :customize-text="customizeLabel" />
        </DxSeries>
        <DxLegend :visible="false" vertical-alignment="bottom" horizontal-alignment="center" />
        <DxTooltip :enabled="true" :precision="2" format="fixedPoint" :customize-tooltip="customizeTooltip" />
      </DxPieChart>
      <div class="total-area" v-if="totalArea > 0" style="margin-top: 10px; font-weight: 600;">
        <span>{{ $t('common.total') }}: {{ totalArea.toFixed(2) }} ha</span>
      </div>
    </div>
    <div v-else style="margin-bottom: 30px">
      <span style="font-style: italic; color: red; font-weight: bold; margin-left: 20px;">
        {{ $t('common.no_data_found') }}
      </span>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { DxPieChart, DxSeries, DxLegend, DxTooltip, DxExport, DxLabel } from "devextreme-vue/pie-chart";
import { DxSelectBox } from "devextreme-vue/select-box";
import DashFilters from "./DashFilters.vue";

export default {
  name: "CropRotation",
  components: {
    DxPieChart,
    DxSeries,
    DxLegend,
    DxTooltip,
    DxLabel,
    DxSelectBox,
    DxExport,
    DashFilters,
  },
  data() {
    return {
      chartData: [],
    };
  },
  computed: {
    ...mapGetters({}),
    totalArea() {
      if (!Array.isArray(this.chartData)) return 0;
      return this.chartData.reduce((sum, item) => sum + (Number(item.area) || 0), 0);
    },
  },
  methods: {
    ...mapActions({
      getCropRotation: "works-parcels/getCropRotation",
    }),
    customizeTooltip({ argument, value, percentText }) {
      if (!value) return;
      const val = Number(value) || 0;
      const pct = percentText || '';
      return { text: `${argument} ${pct ? ' (' + pct + ')' : ''}` };
    },
    customizeLabel(point) {
      try {
        const arg = point.argumentText || point.argument || '';
        const val = Number(point.value) || 0;
        const pct = point.percentText || '';
        return `${arg} ${pct ? ' (' + pct + ')' : ''}`;
      } catch (e) {
        return String(point && point.argumentText ? point.argumentText : '');
      }
    },
    onFilterChanged(filters) {
      this.getCropRotationData(filters);
    },
    getCropRotationData(filters) {
      if (!filters.season_uuid) return;
      const params = {
        season_uuid: filters.season_uuid,
        department_uuids: filters.departments,
        group_uuids: filters.groups,
      };
      this.getCropRotation(params).then((response) => {
        // Assuming response contains the crop rotation data

        this.chartData = []; // Update with actual data from response

        if (response && Array.isArray(response)) {
          this.chartData = response.map((item) => ({
            culture: (item.culture_uuid && item.culture ? item.culture.name : this.$t("common.unknown")) + ` (${ parseFloat(item.total_surface ?? 0).toFixed(2)} ha)`,
            area: item.total_surface,
          }));
        }
      });
    },
    /*downloadChart() {
      this.$refs.pieChart.instance.exportTo('crop-rotation.png', 'PNG');
    },*/
  },
  mounted() {},
};
</script>
<style scoped>
.season_year_select {
  width: 350px;
  margin-top: 15px;
  margin-left: 15px;
  margin-bottom: 15px;
}

.total-area {
  font-size: 16px;
  margin-left: 15px;
}
</style>
